import type { Image } from 'domains/content.d';

/**
 * Get the media query for the given index and image attribute options.
 *
 */
export function getSourceMedia(device: Image) {
  if (!device?.dimensions?.width) return '';

  return `(min-width: ${device.dimensions.width}px)`;
}
